import { render, staticRenderFns } from "./withdraw_set.vue?vue&type=template&id=485088c3&scoped=true&"
import script from "./withdraw_set.vue?vue&type=script&lang=js&"
export * from "./withdraw_set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485088c3",
  null
  
)

export default component.exports